package com.parmartechnologies.ui.component.image

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.parmartechnologies.core.feature.mediaFile.model.MediaFile
import com.parmartechnologies.ui.core.mediaFile.viewModel.MediaFileViewModel
import com.parmartechnologies.ui.media.MediaFilePickerView
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
@Composable
fun ImageView(
    id: String?,
    businessId: String?,
    isEditable: Boolean = false,
    viewModel: MediaFileViewModel = MediaFileViewModel()
) {
    val mediaFile: MutableStateFlow<MediaFile?> = MutableStateFlow(MediaFile())
    val media = mediaFile.collectAsState()
    LaunchedEffect(key1 = Unit) {
        if (id?.isNotEmpty() == true) {
            viewModel.loadMedia(id) { file ->
                viewModel.scope.launch {
                    mediaFile.value?.FileURL = file?.FileURL.toString()
                    if (file?.FileURL.isNullOrEmpty()) {
//                    mediaFile.emit(MediaFile(FileURL = Server.image(id)))
                    } else {
                        mediaFile.emit(file)
                    }
                }
            }
        }
    }
    MediaFilePickerView(id = id, businessId=  businessId,media.value, isEditable, viewModel)
}